// @flow
import React from "react";
import { get } from "lodash";
import { graphql } from "@apollo/client/react/hoc";
import { connect } from "react-redux";
import type { WagerProfile } from "@tvg/types/UserFDR";
import TopPools from "@fdr/atomic-ui/_templates/TopPools";
import type { TopPool } from "@tvg/types/Pool";
import buildRaceUrl from "@tvg/formatter/url";
import { useRequested, sendGTMScrollEvent } from "@tvg/top-pools";
import mediator from "@tvg/mediator";
import ApolloOptions from "@tvg/top-pools/src/graphql/options.graph";
import TopPoolsQuery from "@tvg/top-pools/src/graphql/queries/TopPools.graphql";

type Props = {
  isLoading: boolean,
  wagerProfile: WagerProfile,
  pools: TopPool[],
  title: string,
  shouldUpdate: boolean,
  showHeader?: boolean
};

export const onPoolClick = (pool: TopPool) => {
  mediator.base.dispatch({
    type: "TOP_POOLS:GO_TO_POOL",
    payload: {
      pool,
      isGreyhound: pool.race.isGreyhound,
      url: `${buildRaceUrl(
        pool.trackCode,
        pool.track,
        pool.race.raceNumber
      )}&betType=${get(pool, "wagerType.id")}`
    }
  });
};

export const FDRTopPoolsComponent = ({
  pools,
  isLoading,
  title,
  showHeader = true
}: Props) => {
  const hasRequested = useRequested(isLoading);

  return (
    <TopPools
      pools={pools}
      isLoading={isLoading}
      title={title}
      hasRequested={hasRequested}
      onPoolClick={onPoolClick}
      sendGTMScrollEvent={sendGTMScrollEvent}
      hasHeader={showHeader}
    />
  );
};

export default connect(
  (store) => ({
    wagerProfile: get(store, "userData.user.profile", "FDR-Generic")
  }),
  () => ({})
)(graphql(TopPoolsQuery, ApolloOptions)(FDRTopPoolsComponent));
